import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CardsGrid from './cardsGrid/cardsGrid';
import { getPins } from '../../../../common/services/http/documentsService';
import { SET_PINS } from '../../../../redux/types';
import useTranslate from '../../../../common/hooks/useTranslate';
import { RootState } from '../../../../redux/store';

import './docPinSection.scss';

interface IDocPinSection {
  pinTrigger?: boolean;
}

const DocPinSection: React.FC<IDocPinSection> = () => {
  const [pins, setPins] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const pin = useSelector((state: RootState) => state.pin.pin);
  const impersonate = useSelector((state: RootState) => state.impersonate);
  const { t } = useTranslate();

  useEffect(() => {
    setLoading(true);
    getPins().then((r) => {
      setLoading(false);
      setPins(r.data);
      dispatch({ type: SET_PINS, value: r.data });
    });
  }, [pin, impersonate]);

  return (
    <>
      {pins.length > 0 ? (
        <div className="doc-pin-wrapper section">
          <p className="section-title">{t('HOME.PINS.SECTION_TITLE')}</p>
          <CardsGrid pins={pins} loading={loading} />
        </div>
      ) : null}
    </>
  );
};

export default DocPinSection;
